/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Thresholds_SubtitleInputs */

const en_ui_onboarding_thresholds_subtitle = /** @type {(inputs: Ui_Onboarding_Thresholds_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All three are optional — you can add them later in Settings.`)
};

const de_ui_onboarding_thresholds_subtitle = /** @type {(inputs: Ui_Onboarding_Thresholds_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle drei sind optional – du kannst sie später in den Einstellungen ergänzen.`)
};

/**
* | output |
* | --- |
* | "All three are optional — you can add them later in Settings." |
*
* @param {Ui_Onboarding_Thresholds_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_thresholds_subtitle = /** @type {((inputs?: Ui_Onboarding_Thresholds_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Thresholds_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_thresholds_subtitle(inputs)
	return de_ui_onboarding_thresholds_subtitle(inputs)
});